/* =================== HEADER =================== */
$(function () {
  // Ajusta padding-top da body com base na altura do header
  /* function fixBodyTop() {
    if ($(".header").length && $(".header").css("position") === "fixed") {
      const headerHeight = $(".header").outerHeight();
      $("body").css("padding-top", headerHeight);
    }
  }
  $(window).on("resize", debounce(fixBodyTop, 50));
  $(window).on("load", fixBodyTop); */

  // Menu fixo ao rolar a tela
  const $header = $('.fdx-menu');
  if ($header.length > 0) {
    function toggleHeaderFull() {
      const scrollTop = $(window).scrollTop();
      if (scrollTop > 100) {
        $header.addClass('active');
      } else {
        $header.removeClass('active');
      }
    }
    toggleHeaderFull();
    $(window).on(
      'scroll',
      debounce(function () {
        toggleHeaderFull();
      }, 50),
    );
  }

  
  // CLIMA E TEMPO
  let estado_origem_ip = sessionStorage.getItem("estado_origem_ip");
  if (!estado_origem_ip) {
    $.ajax({
      url: url_base + "acoes/api/dados_localizacao_ip.php",
      success: function (data) {
        if (data != "erro") {
          sessionStorage.setItem("estado_origem_ip", data);
          geraMapaClima();
        }
      },
    });
  } else {
    geraMapaClima();
  }

  function geraMapaClima() {
    estado_origem_ip = sessionStorage.getItem("estado_origem_ip");
    $.ajax({
      url: "https://apiprevmet3.inmet.gov.br/previsao/capitais",
      type: "get",
      async: true,
      dataType: "json",
      success: function (data) {
        console.log(data);
        console.log(estado_origem_ip);
        setTimeout(() => {
          if (estado_origem_ip == "Belem") {
            estado_origem_ip = "Belém";
          }
          if (estado_origem_ip == "Brasilia") {
            estado_origem_ip = "Brasília";
          }
          if (estado_origem_ip == "Cuiaba") {
            estado_origem_ip = "Cuiabá";
          }
          if (estado_origem_ip == "Mato Grosso") {
            estado_origem_ip = "Cuiabá";
          }
          if (estado_origem_ip == "Florianopolis" || estado_origem_ip == "Santa Catarina") {
            estado_origem_ip = "Florianópolis";
          }
          if (estado_origem_ip == "Goiania") {
            estado_origem_ip = "Goiânia";
          }
          if (estado_origem_ip == "Joao Pessoa") {
            estado_origem_ip = "João Pessoa";
          }
          if (estado_origem_ip == "Macapa") {
            estado_origem_ip = "Macapá";
          }
          if (estado_origem_ip == "Maceio") {
            estado_origem_ip = "Maceió";
          }
          if (estado_origem_ip == "Sao Luis" || estado_origem_ip == "Maranhao") {
            estado_origem_ip = "São Luís";
          }
          if (estado_origem_ip == "Sao Paulo") {
            estado_origem_ip = "São Paulo";
          }
          if (estado_origem_ip == "Vitoria") {
            estado_origem_ip = "Vitória";
          }
          if (estado_origem_ip == "Parana") {
            estado_origem_ip = "Curitiba";
          }
          if (estado_origem_ip == "Rio Grande do Sul") {
            estado_origem_ip = "Porto Alegre";
          }
          if (estado_origem_ip == "Mato Grosso do Sul") {
            estado_origem_ip = "Campo Grande";
          }
          if (estado_origem_ip == "Espirito Santo") {
            estado_origem_ip = "Vitória";
          }
          if (estado_origem_ip == "Minas Gerais") {
            estado_origem_ip = "Belo Horizonte";
          }
          if (estado_origem_ip == "Goias") {
            estado_origem_ip = "Goiânia";
          }
          if (estado_origem_ip == "Rondonia") {
            estado_origem_ip = "Porto Velho";
          }
          if (estado_origem_ip == "Bahia") {
            estado_origem_ip = "Salvador";
          }
          if (estado_origem_ip == "Acre") {
            estado_origem_ip = "Rio Branco";
          }
          if (estado_origem_ip == "Amazonas") {
            estado_origem_ip = "Manaus";
          }
          if (estado_origem_ip == "Roraima") {
            estado_origem_ip = "Boa Vista";
          }
          if (estado_origem_ip == "Amapa") {
            estado_origem_ip = "Macapá";
          }
          if (estado_origem_ip == "Para") {
            estado_origem_ip = "Belém";
          }
          if (estado_origem_ip == "Tocantins") {
            estado_origem_ip = "Palmas";
          }
          if (estado_origem_ip == "Bahia") {
            estado_origem_ip = "Salvador";
          }
          if (estado_origem_ip == "Piaui") {
            estado_origem_ip = "Teresina";
          }
          if (estado_origem_ip == "Ceara") {
            estado_origem_ip = "Fortaleza";
          }
          if (estado_origem_ip == "Sergipe") {
            estado_origem_ip = "Aracaju";
          }
          if (estado_origem_ip == "Alagoas") {
            estado_origem_ip = "Maceió";
          }
          if (estado_origem_ip == "Pernambuco") {
            estado_origem_ip = "Recife";
          }
          if (estado_origem_ip == "Paraiba") {
            estado_origem_ip = "João Pessoa";
          }
          if (estado_origem_ip == "Rio Grando do Norte") {
            estado_origem_ip = "Natal";
          }
          let previsao =
            data[estado_origem_ip][$("#data-atual").data("data")]["tarde"];
          console.log(previsao);
          $("#estado-previsao").html(estado_origem_ip);
          $("#imagem-previsao").attr("src", previsao.icone);
          $("#imagem-previsao").attr("alt", previsao.resumo);
          $("#imagem-previsao").attr("title", previsao.resumo);
          $(".header-clima").attr("title", previsao.resumo);
          $(".clima-grau-minima").html(previsao.temp_min + "°C");
          $(".clima-grau-maxima").html(previsao.temp_max + "°C");
          $(".header-clima").removeClass("loading-infos-header");
          $(".header-clima").addClass("show-infos-header");
        }, 0);
      },
      error: function (xhr, type, exception) {
        $(".header-clima").removeClass("loading-infos-header");
        $(".header-clima").addClass("hide-infos-header");
      },
    });
  }

});

$(document).ready(function () {
  $('.header-mobile-search').click(function () {
    $('.segura-busca-mobile').slideToggle();
  });
});
